import { isPlainObject } from "@/utils/shared"
import axios from "axios"

// 判断是否为服务端包装的数据结构
export const isAxiosResponseWrapper = (responseData) => {
  if (isPlainObject(responseData)) {
    return "data" in responseData && "code" in responseData && "msg" in responseData
  }

  return false
}

const instance = axios.create({
  withCredentials: true
})

// 响应拦截器
instance.interceptors.response.use(
  (config) => {
    if (isAxiosResponseWrapper(config.data)) {
      config.data = config.data.data
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default instance
